import { Mark } from '@/components/brand/Brand'

/* The first partner firm, in their own words. */
export const VoicesSection = () => (
  <section className="x-voices" aria-label="What Ridge Paragon says">
    <div className="x-wrap x-voices-grid">
      <figure className="x-voices-photo">
        <img
          src="/media/home/doug-cristal-ridge-paragon.avif"
          alt="Doug, owner of Ridge Paragon, laughing during a conversation"
          width="900"
          height="1600"
          loading="lazy"
        />
      </figure>
      <div className="x-voices-text">
        <blockquote className="x-q1">
          <p>“We can already take on 2x more clients today, perhaps 3x soon.”</p>
        </blockquote>
        <blockquote className="x-q2">
          <p>
            “This never felt like selling control. Our name, team, and clients stayed with us, and we gained a stake in a bigger
            story, operating system, engineering support, and capacity we could not realistically build alone.”
          </p>
        </blockquote>
        <p className="x-voices-credit">
          <span className="x-voices-mark">
            <Mark />
          </span>
          Doug and Cristal from Ridge Paragon
        </p>
      </div>
    </div>
  </section>
)
